import { createFileRoute } from '@tanstack/react-router';
import { ApplyPage } from '@/features/travel-credit-card/apply/apply-page';
import { resolveDevice } from '@/features/travel-credit-card/constants/device';
import { APPLY_CONTENT } from '@/features/travel-credit-card/content/content';
import {
	ForceLightScheme,
	forceLightSchemeScript,
} from '@/features/travel-credit-card/layout/force-light-scheme';
import { seo } from '@/utils/seo';

// /travel-credit-card/apply — CBCC application form. The `_` suffix in the
// filename un-nests this from the /travel-credit-card route (which renders the
// landing page directly, with no Outlet). Per-user form page: stays SPA
// (app default) and inherits the root noindex.
export const Route = createFileRoute('/travel-credit-card_/apply')({
	head: () => ({
		meta: [
			...seo({
				title: `Apply — ${APPLY_CONTENT.form.title}`,
				description: APPLY_CONTENT.form.title,
			}),
		],
		// Pin color-scheme: light for this route (see force-light-scheme.tsx).
		scripts: [{ children: forceLightSchemeScript }],
	}),
	// Resolve from the User-Agent; a missing UA uses CBCC's mobile-first default.
	loader: () => ({ device: resolveDevice() }),
	component: ApplyRoute,
});

function ApplyRoute() {
	const { device } = Route.useLoaderData();
	return (
		<>
			<ForceLightScheme />
			<ApplyPage device={device} />
		</>
	);
}
